import { render, staticRenderFns } from "./FormSplit.vue?vue&type=template&id=072e3156&lang=html&"
import script from "./FormSplit.vue?vue&type=script&lang=js&"
export * from "./FormSplit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormSplit.vue"
export default component.exports